import { ReactNode } from 'react'
import classNames from 'classnames'

import { DotsLoader } from 'app/common/components/Loader'

import styles from './option-prop.module.scss';


export type OptionPropProps = {
  title: string
  children: ReactNode
  className?: string
  loading?: boolean
}

const OptionProp = ({ title, children, className, loading }: OptionPropProps) => (
  <>
    <dt className={classNames(styles.dt, className)}>{title}</dt>
    <dd className={styles.dd}>
      {loading
        ? <DotsLoader simple />
        : children}
    </dd>
  </>
)

export default OptionProp
